// 电池详情
export default {
    owner: '拥有者',
    phone: '手机号',
    aircraftNumber: '飞行器编号',
    chargerNumber: '充电器编号',
    reportingTime: '上报时间',
    TUT: '使用总时间',
    TOC: '循环次数',
    ODT: '过放次数',
    BLS: '电池寿命统计',
    residualLife: '剩余寿命',
}